import { IResponseBaseTDto } from '@sprytki-frontend-apps/common';
import { IUserDetailsDto } from 'api/interfaces/user';
import { storageKeys } from 'shared/constants';
import { apiClient } from './apiClient';


export const UserServiceAPI = {
	requestPasswordReset: async (email: string, languageAbbreviation: string): Promise<boolean> => {
		try {
			const response = await apiClient.post('users/request-password-reset', { email, languageAbbreviation });
			if (!response.data.success) throw new Error(response.data.errors[0]?.errorCode);
			return true;
		} catch (error) {
			throw error;
		}
	},
	resetPassword: async (token: string, newPassword: string): Promise<boolean> => {
		try {
			const response = await apiClient.post('users/reset-password', { token, newPassword });
			if (!response.data.success) throw new Error(response.data.errors[0]?.errorCode);
			return true;
		} catch (error) {
			throw error;
		}
	},
	changePassword: async (password: string, newPassword: string): Promise<boolean> => {
		const response = await apiClient.post('users/change-password', { oldPassword: password, newPassword });

		if (!response.data.success) throw new Error(response.data.errors[0]?.errorCode);

		const { accessToken, refreshToken } = response.data.data;
		const rememberMe = Boolean(localStorage.getItem(storageKeys.REMEMBER_ME));

		if (rememberMe) {
			localStorage.setItem(storageKeys.ACCESS_TOKEN, accessToken);
			localStorage.setItem(storageKeys.REFRESH_TOKEN, refreshToken);
		} else {
			sessionStorage.setItem(storageKeys.ACCESS_TOKEN, accessToken);
			sessionStorage.setItem(storageKeys.REFRESH_TOKEN, refreshToken);
		}

		return true;
	},
	getById: async (id: string): Promise<IResponseBaseTDto<IUserDetailsDto>> => {
		const response = await apiClient.get<IResponseBaseTDto<IUserDetailsDto>>(`users/${id}`);
		return response.data;
	},
}
